import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient } from '@angular/common/http';
import { A11yModule } from '@angular/cdk/a11y';

import { ClickOutsideModule } from 'ng-click-outside';
import { TableModule } from 'primeng/table';
import { SelectModule } from 'primeng/select';
import { TooltipModule } from 'primeng/tooltip';
import { DatePickerModule } from 'primeng/datepicker';
import { TreeModule } from 'primeng/tree';
import { ProgressBarModule } from 'primeng/progressbar';
import { ColorPickerModule } from 'primeng/colorpicker';

import { LocalizationModule } from '../../Core/Localization/localization.module';
import { MiscModule } from '../Misc/misc.module';
import { LayoutModule } from '../Layout/layout.module';
import { CommonBasicModule } from '../Basic/basic.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { TakeOverModule } from '../TakeOver/take-over.module';
import { ChartsModule } from '../../Common/Charts/charts.module';

import { TVEyesTimelineService } from './services/tveyes-timeline.service';
import { TVEyesMentionsService } from '../Mentions/services/tveyes-mentions.service';
import { MentionSearchVarsService } from './services/mention-search-vars.service';
import { AgentsApiService } from '../../api/agents/agents.api';

import { AmplifyDialogComponent } from './components/AmplifyDialog/amplify-dialog.component';
import { DataSelectDialogComponent } from './components/DataSelectDialog/data-select-dialog.component';
import { DataSelectTakeoverPanelComponent } from './components/DataSelectTakeoverPanel/data-select-takeover-panel.component';
import { ProgressDialogComponent } from './components/ProgressDialog/progress-dialog.component';
import { PublishStoryComponent } from './components/PublishStory/publish-story.component';
import { TextInputDialogComponent } from './components/TextInputDialog/text-input-dialog.component';
import { ColorPickerDialogComponent } from './components/ColorPickerDialog/color-picker-dialog.component';
import { ConfirmDialogComponent } from './components/ConfirmDialog/confirm-dialog.component';
import { BulkActionConfirmationDialogComponent } from './components/BulkActionConfirmationDialog/bulk-action-confirmation-dialog.component';
import { IframeDialogComponent } from './components/IframeDialog/iframe-dialog.component';
import { NewEntityDialogComponent } from './components/NewEntityDialog/new-entity-dialog.component';
import { DateQueryInputDialogComponent } from './components/DateQueryInputDialog/date-query-input-dialog.component';
import { SaveStylesDialogComponent } from './components/SaveStylesDialog/save-styles-dialog.component';
import { CsvImportDialogComponent } from './components/CsvImportDialog/csv-import-dialog.component';
import { SaveTwigTemplateDialogComponent } from './components/SaveTwigTemplateDialog/save-twig-template-dialog.component';
import { ImageLightBoxComponent } from './components/ImageLightBox/image-light-box.component';
import { LinkDialogComponent } from './components/LinkDialog/link-dialog.component';
import { ResearchRequestDialogComponent } from './components/ResearchRequestDialog/research-request-dialog.component';
import { AIHelperDialogComponent } from './components/AIHelperDialog/AI-helper-dialog.component';
import { AIRefinementDialogComponent } from './components/AIRefinementDialog/AI-refinement-dialog.component';
import { AIRefinementPopupComponent } from './components/AIRefinementPopup/AI-refinement-popup.component';
import { G2ReviewDialogComponent } from './components/G2ReviewDialog/g2-review-dialog.component';
import { TVEyesArchiveDialogComponent } from './components/TVEyesArchiveDialog/tveyes-archive-dialog.component';
import { GhostInDialogComponent } from './components/GhostInDialog/ghost-in-dialog.component';
import { UpsellInfoDialogComponent } from './components/UpsellInfoDialog/upsell-info-dialog.component';
import { EditInsightDialogComponent } from './components/EditInsightDialog/edit-insight-dialog.component';
import { FallbackPersonalizationsDialogComponent } from './components/FallbackPersonalizationsDialog/fallback-personalizations-dialog.component';
import { GroupSelectionDialogComponent } from './components/GroupSelectionDialog/group-selection-dialog.component';
import { PostExportSetupDialogComponent } from './components/PostExportSetupDialog/post-export-setup-dialog.component';
import { NewResourceDialogComponent } from './components/NewResourceDialog/new-resource-dialog.component';
import { TVEyesMediaViewDialogComponent } from './components/TVEyesMediaViewDialog/tveyes-mediaview-dialog.component';
import { PreviewTextDialogComponent } from './components/PreviewTextDialog/preview-text-dialog.component';
import { RichTextEditorDialogComponent } from './components/RichTextEditorDialog/rich-text-editor-dialog.component';
import { PostViewerDialogComponent } from './components/PostViewerDialog/post-viewer-dialog.component';
import { SocialPostArticleComponent } from './components/PostViewerDialog/SocialPostArticle/social-post-article.component';
import { SocialPostDetailsComponent } from './components/PostViewerDialog/SocialPostDetails/social-post-details.component';
import { SocialPostDisplayComponent } from './components/PostViewerDialog/SocialPostDisplay/social-post-display.component';
import { SocialPostFoldersComponent } from './components/PostViewerDialog/SocialPostFolders/social-post-folders.component';
import { ConfirmCancelDialogComponent } from './components/ConfirmCancelDialog/confirm-cancel-dialog.component';
import { LibraryMoveDialogComponent } from './components/LibrarySelectionDialog/library-selection-dialog.component';
import { SessionExpiredDialogComponent } from './components/SessionExpiredDialog/session-expired-dialog.component';
import { SessionExpiryConfirmDialogComponent } from './components/SessionExpiryConfirmDialog/session-expiry-confirm-dialog.component';
import { AIContextTakeoverComponent } from './components/AIContextTakeover/ai-context-takeover.component';
import { ChartAnnotationDialogComponent } from './components/ChartAnnotationDialog/chart-annotation-dialog.component';
import { ChartAnnotationIndicatorsService } from './components/ChartAnnotationDialog/chart-annotation-indicators.service';
import { ChangeTimeZonePipe } from '../Misc/pipes/ChangeTimeZone/change-time-zone.pipe';

export const commonDialogsImports = [
    SelectModule,
    TableModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TooltipModule,
    ProgressBarModule,
    TreeModule,
    MiscModule,
    LocalizationModule,
    DatePickerModule,
    ColorPickerModule,
    CommonFormsModule,
    LayoutModule,
    CommonBasicModule,
    CoreDialogsModule,
    ClickOutsideModule,
    A11yModule,
    TakeOverModule,
    ChartsModule
];
export const commonDialogDeclarations = [
    AmplifyDialogComponent,
    DataSelectDialogComponent,
    DataSelectTakeoverPanelComponent,
    ProgressDialogComponent,
    PublishStoryComponent,
    TextInputDialogComponent,
    ColorPickerDialogComponent,
    ConfirmDialogComponent,
    BulkActionConfirmationDialogComponent,
    IframeDialogComponent,
    NewEntityDialogComponent,
    DateQueryInputDialogComponent,
    SaveStylesDialogComponent,
    CsvImportDialogComponent,
    SaveTwigTemplateDialogComponent,
    ImageLightBoxComponent,
    LinkDialogComponent,
    ResearchRequestDialogComponent,
    AIHelperDialogComponent,
    AIRefinementDialogComponent,
    AIRefinementPopupComponent,
    G2ReviewDialogComponent,
    TVEyesArchiveDialogComponent,
    TVEyesMediaViewDialogComponent,
    GhostInDialogComponent,
    UpsellInfoDialogComponent,
    EditInsightDialogComponent,
    FallbackPersonalizationsDialogComponent,
    GroupSelectionDialogComponent,
    PostExportSetupDialogComponent,
    NewResourceDialogComponent,
    PreviewTextDialogComponent,
    RichTextEditorDialogComponent,
    PostViewerDialogComponent,
    SocialPostDetailsComponent,
    SocialPostDisplayComponent,
    SocialPostFoldersComponent,
    SocialPostArticleComponent,
    ConfirmCancelDialogComponent,
    LibraryMoveDialogComponent,
    SessionExpiredDialogComponent,
    SessionExpiryConfirmDialogComponent,
    AIContextTakeoverComponent,
    ChartAnnotationDialogComponent
];
@NgModule({
    imports: commonDialogsImports,
    declarations: commonDialogDeclarations,
    exports: [
        AmplifyDialogComponent,
        DataSelectDialogComponent,
        DataSelectTakeoverPanelComponent,
        ProgressDialogComponent,
        PublishStoryComponent,
        TextInputDialogComponent,
        ColorPickerDialogComponent,
        ConfirmDialogComponent,
        BulkActionConfirmationDialogComponent,
        IframeDialogComponent,
        NewEntityDialogComponent,
        DateQueryInputDialogComponent,
        SaveStylesDialogComponent,
        CsvImportDialogComponent,
        ImageLightBoxComponent,
        LinkDialogComponent,
        AIHelperDialogComponent,
        AIRefinementDialogComponent,
        AIRefinementPopupComponent,
        G2ReviewDialogComponent,
        UpsellInfoDialogComponent,
        EditInsightDialogComponent,
        FallbackPersonalizationsDialogComponent,
        GroupSelectionDialogComponent,
        PostExportSetupDialogComponent,
        NewResourceDialogComponent,
        RichTextEditorDialogComponent,
        PreviewTextDialogComponent,
        PostViewerDialogComponent,
        ConfirmCancelDialogComponent,
        SessionExpiredDialogComponent,
        SessionExpiryConfirmDialogComponent,
        AIContextTakeoverComponent,
        ChartAnnotationDialogComponent
    ],
    providers: [
        provideHttpClient(),
        TVEyesTimelineService,
        TVEyesMentionsService,
        MentionSearchVarsService,
        AgentsApiService,
        ChartAnnotationIndicatorsService,
        ChangeTimeZonePipe
    ]
})
export class CommonDialogsModule { }
